/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: DeleteProjectRoleDialog.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-ROLES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * DeleteProjectRoleDialog - Frontend UI module: DeleteProjectRoleDialog.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: контракты функций, парные END_METHOD, блок удаления.
 * END_CHANGE_SUMMARY
 */

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useState } from 'react';

/* START_METHOD_DeleteProjectRoleDialog */
/* START_CONTRACT: DeleteProjectRoleDialog
 * PURPOSE: Диалог подтверждения удаления проектной роли.
 * INPUTS: { open: boolean, onClose: ()=>void, onConfirm: (id)=>Promise, role: ProjectRole }.
 * OUTPUTS: { JSX.Element|null - диалог }.
 * SIDE_EFFECTS: вызов onConfirm (HTTP наверх); локальный state.
 * LINKS: M-FE-ROLES
 * END_CONTRACT: DeleteProjectRoleDialog
 */
export default function DeleteProjectRoleDialog({ open, onClose, onConfirm, role }) {
  const [loading, setLoading] = useState(false);

  if (!role) return null;

  /* START_METHOD_handleConfirm */
  /* START_CONTRACT: handleConfirm
   * PURPOSE: Удалить проектную роль; при успехе закрыть диалог.
   * INPUTS: {}.
   * OUTPUTS: { Promise<void> }.
   * SIDE_EFFECTS: onConfirm (HTTP); setLoading; onClose.
   * LINKS: M-FE-ROLES
   * END_CONTRACT: handleConfirm
   */
  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm(role.id);
      /* START_BLOCK_DELETE_OK */
      onClose();
      /* END_BLOCK_DELETE_OK */
    } finally {
      setLoading(false);
    }
  };
  /* END_METHOD_handleConfirm */

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: '1rem' }}>Удаление проектной роли</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Удалить роль «{role.name}» ({role.shortName})? Это действие нельзя отменить.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={handleConfirm}
          disabled={loading}
        >
          Удалить
        </Button>
        <Button size="small" onClick={onClose} disabled={loading}>
          Отмена
        </Button>
      </DialogActions>
    </Dialog>
  );
}
/* END_METHOD_DeleteProjectRoleDialog */
